<h3 mat-dialog-title>Altera Visão do Usuário</h3>

<div mat-dialog-content style="width: 100%">
    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf='habilitaEscritorio'>
        <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Escritório</mat-label>
            <mat-select 
                placeholder="Escritório"                
                [formControl]="escritorio_id" 
                (selectionChange)="selectEscritorio($event)">
                <mat-option value="" *ngIf="usuario.role_id == 1 || usuario.role_id == 2 || usuario.role_id == 7 || usuario.role_id == 13">TODOS</mat-option>
                <mat-option *ngFor="let escritorio of listEscritorios"
                    [value]="escritorio.id">{{escritorio.nome_fantasia}}</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerEscritorio"></mat-spinner> 
        </mat-form-field>
    </div>
 
    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf="!habilitaEscritorio">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="1000">
            <mat-label>Assessor</mat-label>
            <mat-select placeholder="Assessor"
                        [formControl]="assessor_id"
                        name="assessor_id" >
                <mat-option value="">Selecione...</mat-option>
                <mat-option *ngFor="let assessor of listAssessor" [value]="assessor.id">{{assessor.name}}</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerAssessor"></mat-spinner>
        </mat-form-field>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button mat-button (click)="filtrar()" tabindex="-1">Alterar</button>
</div>